import type { MessagingCreateChatRoom201ParticipantsItemBasicInfo } from './messagingCreateChatRoom201ParticipantsItemBasicInfo';
import type { MessagingCreateChatRoom201ParticipantsItemSocial } from './messagingCreateChatRoom201ParticipantsItemSocial';

/**
 * 간략한 사용자 정보
 */
export type MessagingCreateChatRoom201ParticipantsItem = {
  /** 사용자 기본 정보 */
  basicInfo: MessagingCreateChatRoom201ParticipantsItemBasicInfo;
  /** 소셜 관계 정보 */
  social?: MessagingCreateChatRoom201ParticipantsItemSocial;
};
